import { API_URL } from "../config/api";

interface VersionResponse {
  version?: string;
  build?: string;
  build_date?: string;
  git_hash?: string;
  environment?: string;
  [key: string]: any;
}

interface DetailedVersionResponse {
  version: string;
  build: string;
  build_date: string;
  git_hash: string;
  environment: string;
  details: {
    [key: string]: any;
  };
}

export const getVersion = async (): Promise<VersionResponse> => {
  try {
    const response = await fetch(`${API_URL}/version/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch version:', error);
    // Return fallback data if API fails
    return {
      version: '1.0.0',
      build: '825',
      build_date: new Date().toISOString(),
      environment: 'development'
    };
  }
};

export const getDetailedVersion = async (): Promise<DetailedVersionResponse | string> => {
  try {
    const response = await fetch(`${API_URL}/version/detailed`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch detailed version:', error);
    // Return fallback string if API fails
    return 'v1.0.0-build.825';
  }
}; 